export const TextClass = "text-base font-plexSans max-w-prose text-left subpixel-antialiased";

export const AnchorLinkClass =
    "text-jade-primary underline underline-offset-4 decoration-1 hover:decoration-2 decoration-jade-primary subpixel-antialiased transition duration-200 cursor-pointer";
